import type {z} from "zod";

import {ConvertLeadToClientBody, LeadDto} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

export const convertLeadToClientFormSchema = zod.object({
  leadId: LeadDto.shape.leadId,
  companyId: ConvertLeadToClientBody.shape.companyId,
});
export type ConvertLeadToClientFormPayload = z.output<typeof convertLeadToClientFormSchema>;

export const draftConvertLeadToClientFormSchema = convertLeadToClientFormSchema.partial();
export type DraftConvertLeadToClientFormPayload = z.output<
  typeof draftConvertLeadToClientFormSchema
>;
